export default __webpack_public_path__ + "static/media/12-28-12-bowie.463407ed.m4a";